import { Reducer } from 'react';

import {
  PaymentCardProductType,
  PaymentCardSortBy,
  PaymentCardStatusFilter,
  SortOrder,
} from '__generated__/GQL';

import { CardsView } from '../../constants';

export type State = {
  view: CardsView;
  canViewCompanyCards: boolean;
  filters: {
    status: PaymentCardStatusFilter[];
    cardHolderName: string[];
    cardProductType: PaymentCardProductType[];
  };
  ordering: {
    [PaymentCardSortBy.OwnerName]: SortOrder;
    [PaymentCardSortBy.LimitPayment]: SortOrder;
    [PaymentCardSortBy.Status]: SortOrder;
    currentOrdering: {
      sortBy: PaymentCardSortBy;
      orderBy: SortOrder;
    };
  };
};

export type Action =
  | {
      type: 'UPDATE_CARDS_VIEW';
      payload: CardsView;
    }
  | {
      type: 'TOGGLE_STATUS_FILTER';
      payload: PaymentCardStatusFilter;
    }
  | {
      type: 'TOGGLE_CARD_HOLDER_FILTER';
      payload: string;
    }
  | {
      type: 'TOGGLE_CARD_PRODUCT_TYPE_FILTER';
      payload: PaymentCardProductType;
    }
  | {
      type: 'UPDATE_SORT_ORDER_BY';
      payload: {
        sortBy: PaymentCardSortBy;
        orderBy: SortOrder;
      };
    }
  | {
      type: 'RESET_FILTERS';
    };

export const paymentCardListFiltersReducer: Reducer<State, Action> = (
  state,
  action,
) => {
  switch (action.type) {
    case 'UPDATE_CARDS_VIEW':
      if (action.payload === CardsView.OWN) {
        return {
          ...state,
          filters: {
            ...state.filters,
            owner: [],
          },
          view: !state.canViewCompanyCards ? CardsView.OWN : action.payload,
        };
      }
      return {
        ...state,
        view: !state.canViewCompanyCards ? CardsView.OWN : action.payload,
      };
    case 'TOGGLE_STATUS_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          status: state.filters.status.includes(action.payload)
            ? state.filters.status.filter((status) => status !== action.payload)
            : [...state.filters.status, action.payload],
        },
      };
    case 'TOGGLE_CARD_HOLDER_FILTER': {
      return {
        ...state,
        filters: {
          ...state.filters,
          cardHolderName: state.filters.cardHolderName.includes(action.payload)
            ? state.filters.cardHolderName.filter(
                (owner) => owner !== action.payload,
              )
            : [...state.filters.cardHolderName, action.payload],
        },
      };
    }
    case 'TOGGLE_CARD_PRODUCT_TYPE_FILTER': {
      return {
        ...state,
        filters: {
          ...state.filters,
          cardProductType: state.filters.cardProductType.includes(
            action.payload,
          )
            ? state.filters.cardProductType.filter(
                (type) => type !== action.payload,
              )
            : [...state.filters.cardProductType, action.payload],
        },
      };
    }
    case 'UPDATE_SORT_ORDER_BY': {
      return {
        ...state,
        ordering: {
          ...state.ordering,
          [action.payload.sortBy]: action.payload.orderBy,
          currentOrdering: {
            orderBy: action.payload.orderBy,
            sortBy: action.payload.sortBy,
          },
        },
      };
    }
    case 'RESET_FILTERS':
      return {
        ...state,
        filters: {
          cardHolderName: [],
          cardProductType: [],
          status: [],
        },
        ordering: {
          [PaymentCardSortBy.OwnerName]: SortOrder.Desc,
          [PaymentCardSortBy.LimitPayment]: SortOrder.Desc,
          [PaymentCardSortBy.Status]: SortOrder.Asc,
          currentOrdering: {
            orderBy: SortOrder.Asc,
            sortBy: PaymentCardSortBy.Status,
          },
        },
      };
    default:
      return state;
  }
};
